module.exports = __webpack_public_path__ + "static/image4-8090c7369d3e7eb35e2d00a184e66c83.jpg";